// extracted by mini-css-extract-plugin
export default {"container":"imprint_container__StxRM","layout":"imprint_layout__ahCGE","back_btn":"imprint_back_btn__CxW2M"};